import React from 'react';
import { connect } from 'react-redux';
import './chat.css';
import fileImage from '../../../../../static/images/admin/chat/69410.png';
import sendImage from '../../../../../static/images/admin/chat/calque-1023.png';
import { db } from './firebase';


const getTime = (dateFormat) =>{

  var date = new Date(dateFormat)

  var year = date.getFullYear();
  var month = date.getMonth() + 1; //getMonth is zero based;
  var day = date.getDate();
  var time = date.getHours() + ':' + date.getHours();
  var formatted = day + '.' + month + '.' + year + ' ' + time;
  return formatted;
} 

const MessageSent = ({ sentMessage, message }) => {


  return <div className="message sent">
    {sentMessage}
    <span className="metadata">
      <span className="time">{ getTime(message.date) } </span>
    </span>
  </div>
};

const MessageRecieved = ({ receivedMessage,       message }) => {

  var date = new Date(message.date)

  var year = date.getFullYear();
  var month = date.getMonth() + 1; //getMonth is zero based;
  var day = date.getDate();
  var time = date.getHours() + ':' + date.getHours();
  var formatted = day + '.' + month + '.' + year + ' ' + time;


 return  <div className="message received">
    {receivedMessage}
    <span className="metadata">
      <span className="time"> { getTime(message.date) } </span>
    </span>
  </div>
};

class Chat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      details: [],
    };
  }

  componentDidMount() {
    db.ref(`Channel/${this.props.details.order.channel_id}/Messages`).on(
      'value',
      snapshot => {
        const messages = snapshot.val();
        messages && this.setState({ messages: [...Object.values(messages)] });
      },
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Load new data when the dataSource property changes.
    if (nextProps.details !== this.props.details) {
      this.setState({ details: nextProps.details });
      db.ref(`Channel/${nextProps.details.order.channel_id}/Messages`).on(
        'value',
        snapshot => {
          const messages = snapshot.val();
          messages
            ? this.setState({ messages: [...Object.values(messages)] })
            : this.setState({ messages: [] });
        },
      );
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const value = e.target.input.value; // safer than elements[0]
  
      if (!value || value.trim() === '') return;
  
      const date = new Date().toISOString();
      const channelId = this.props.details?.order?.channel_id;
      if (!channelId) return console.warn("No channel ID defined");
      
      try {
        await db.ref(`Channel/${channelId}/Messages`).push({
          date: new Date().toISOString(),
          message: value,
          seen: false,
          senderID: this.props.userId,
        });
      } catch (error) {
        console.warn("Firebase write blocked:", error);
      }
  
      e.target.reset();
  
    } catch (error) {
      // Prevent crash
      console.warn("Firebase write blocked:", error.message);
  
      // OPTIONAL: show user-friendly message
      // alert("Message not sent (permission issue)");
    }
  };

  render() {
    const { messages } = this.state;
    const { userId } = this.props;
    const procuderSize = typeof this.props.producer === 'undefined' ? true : false; 
    return (
      <div className={procuderSize ? "page" : "page1"}>
        <div className="chat">
          <div className="chat-container">
            <div className="conversation">
              <div className="conversation-container">
                {messages.map((message, index) => {
                  return message.senderID === userId ? (
                    <MessageSent key={index} sentMessage={message.message}       message={message} />
                  ) : (
                    <MessageRecieved
                      key={index}
                      receivedMessage={message.message}
                      message={message}
                    />
                  );
                })}
              </div>
              <form
                className="conversation-compose"
                onSubmit={e => this.handleSubmit(e)}
              >
                <input
                  className="input-msg"
                  name="input"
                  placeholder={
                    this.props.language.locale === 'DE'
                      ? 'Nachricht schreiben'
                      : 'Type a message '
                  }
                  autoComplete="off"
                  autoFocus
                />
                <div className="photo">
                  <img src={fileImage} alt="" />
                </div>
                <button className="send">
                  <div className="circle">
                    <img src={sendImage} alt="" />
                  </div>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {};
}

const mapStateToProps = state => {
  const { language } = state.toJS();
  return {
    language,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
